import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';
import Ctas from '../../../Core/Ctas';

import {
  StyledContainer,
  Wrapper,
  Img,
  Content,
  Title,
  BodyCopy,
} from './styles';

const body = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <p>{children}</p>,
  },
};

const CampaignOptimumBanner = ({ data }) => {
  if (!data) return null;

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Title as="p" className={headingStyle}>
          {children}
        </Title>
      ),
      [BLOCKS.HEADING_1]: (_, children) => (
        <Title as="h1" className={headingStyle}>
          {children}
        </Title>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <Title as="h2" className={headingStyle}>
          {children}
        </Title>
      ),
      [BLOCKS.HEADING_3]: (_, children) => (
        <Title as="h3" className={headingStyle}>
          {children}
        </Title>
      ),
    },
  };

  const {
    heading,
    bodyCopy,
    backgroundImageDam,
    imageDam,
    ctas,
    component,
    backgroundColor,
    optimumStyle,
    headingStyle,
  } = data;

  return (
    <StyledContainer
      image={
        backgroundImageDam ? backgroundImageDam.asset.localImage.publicURL : ''
      }
      className={`${component} ${backgroundColor}`}
      optimumStyle={optimumStyle}
    >
      <Wrapper>
        {imageDam && <Img src={imageDam} alt={imageDam.altText || ''} />}
        {(header || bodyCopy) && (
          <Content>
            {header && <RichText document={heading} options={header} />}
            {(bodyCopy || ctas) && (
              <BodyCopy>
                {bodyCopy && <RichText document={bodyCopy} options={body} />}
                {ctas && <Ctas ctas={ctas} />}
              </BodyCopy>
            )}
          </Content>
        )}
      </Wrapper>
    </StyledContainer>
  );
};

CampaignOptimumBanner.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default CampaignOptimumBanner;
